import React from "react";
import { DataTable, RiskStatusIcon, Table } from "@sscs/ui";
import { categoryToTitle } from "../../../constants";
import { expandedRowsUpdated, focusedRowUpdated, selectExpandedRow, selectFocusedRow, selectStatusFilter, } from "../../../store/issuesSlice";
import { generateOverrideId } from "../../../utils";
import { IssueOverrides } from "../../common";
import { useReportDispatch, useReportSelector } from "../../hooks";
import styles from "./issue.module.scss";
import IssueDetails from "./IssueDetails";
const Issue = ({ issue }) => {
    const dispatch = useReportDispatch();
    const expanded = useReportSelector((state) => selectExpandedRow(state, issue.id));
    const focusedRow = useReportSelector(selectFocusedRow);
    const statusFilter = useReportSelector(selectStatusFilter);
    return (React.createElement(DataTable.ExpandedRow, { expanded: expanded, focused: focusedRow === issue.id, onChange: (isExpanded) => dispatch(expandedRowsUpdated({
            id: issue.id,
            overrideIds: issue.overrides.map((override) => generateOverrideId(override)),
            expand: isExpanded,
        })), onClick: () => dispatch(focusedRowUpdated(issue.id)) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null, issue.id),
            React.createElement(Table.Cell, null,
                issue.description,
                issue.assessment_label && issue.assessment_status && (React.createElement("div", { className: styles["risk-assessment"] },
                    React.createElement("span", null, "Causes risk:"),
                    React.createElement(RiskStatusIcon, { status: issue.assessment_status, disabled: false }),
                    React.createElement("span", null, issue.assessment_label)))),
            React.createElement(Table.Cell, null, issue.policy_category
                ? categoryToTitle[issue.policy_category]
                : "Unknown"),
            React.createElement(IssueOverrides, { issue: issue, statusFilter: statusFilter })),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(IssueDetails, { issue: issue }))));
};
export default Issue;
//# sourceMappingURL=Issue.js.map